// extracted by mini-css-extract-plugin
export default {"description":"profile-map_description__N4P-Z"};